import { POST, SUCCESS } from "../../utils/const/http-const";
import { getHeaders } from "../utils";
// import { GET } from "../../utils/const/http-const";

export async function obtenerReporteInfoKilometraje(obj) {
    try {
        let response = { error: true, data: null };
        const { code, data, mensaje } = await fetch(
            "https://gestiondeflota.boltrack.net/reportes/RP502BodyV14.rep",
            {
                headers: getHeaders(false),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('data');
        // console.log(data);
        // console.log('mensaje');
        // console.log(mensaje);
        if (code === SUCCESS && data !== undefined && data !== null) {
            response.error = false;
            response.data = data;
        }
        return response;
    } catch (err) {
        console.log("obtenerReporteInfoKilometraje err");
        console.log(err);
        return { error: true, data: null };
    }
}